import { FetchClient } from "../../utils/fetchClient";

export function getAllCampaigns() {
    return FetchClient(`/data/eight-by-eight/campaigns`).GET({})
}